import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { GEMOGRAPHICS_COUNTY_DROPDOWN_OPTIONS,
  GEMOGRAPHICS_ZIPCODE_DROPDOWN_OPTIONS } from './GeoMapConstant';
import CommonSelect from '../common/CommonSelect';
import * as geoMappingActions from '../../actions/geoMappingActions';

class CountyAndZipCodeCategoryDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCountyCategoryLabel: _.find(GEMOGRAPHICS_COUNTY_DROPDOWN_OPTIONS,
        { value: this.props.countyCategorySelectedVal }).label,
      selectedZipcodeCategoryLabel: _.find(GEMOGRAPHICS_ZIPCODE_DROPDOWN_OPTIONS,
        { value: this.props.zipcodeCategorySelectedVal }).label,
    };
  }

  onCategoryChange = e => {
    const { selectedTab, clearAll } = this.props;

    if (selectedTab === 'county') {
      const obj = _.find(GEMOGRAPHICS_COUNTY_DROPDOWN_OPTIONS, { value: e });
      this.setState({ selectedCountyCategoryLabel: obj.label });
    }
    if (selectedTab === 'zipcode') {
      const obj = _.find(GEMOGRAPHICS_ZIPCODE_DROPDOWN_OPTIONS, { value: e });
      this.setState({ selectedZipcodeCategoryLabel: obj.label });
    }
    clearAll();
    this.props.geoMappingActions.updateCountyAndZipcodeCategory(selectedTab, e);
  }
  
  renderGeographicsCountyCatDropdown = () => (
    <CommonSelect
      data-test="CustomSelectComp"
      cClass="mme-rpt-second-select"
      field={GEMOGRAPHICS_COUNTY_DROPDOWN_OPTIONS}
      onSelection={this.onCategoryChange}
      defaultValue={this.props.countyCategorySelectedVal}
      defaultLabel={this.state.selectedCountyCategoryLabel}
      downArrow
      width="175px"
      buttonStyle={{
        border: '1px solid #91a2b9',
        fontWeight: '400',
        color: '#30435d',
        height: '30px',
        marginBottom: '15px' }}
    />
  )

  renderGeographicsZipcodeCatDropdown = () => (
    <CommonSelect
      data-test="CustomSelectComp"
      cClass="mme-rpt-second-select"
      field={GEMOGRAPHICS_ZIPCODE_DROPDOWN_OPTIONS}
      onSelection={this.onCategoryChange}
      defaultValue={this.props.zipcodeCategorySelectedVal}
      defaultLabel={this.state.selectedZipcodeCategoryLabel}
      downArrow
      width="175px"
      buttonStyle={{
        border: '1px solid #91a2b9',
        fontWeight: '400',
        color: '#30435d',
        height: '30px',
        marginBottom: '15px' }}
    />
  )

  render() {
    const { selectedTab } = this.props;
    return (
      <div className="row" data-test="countyAndZipcodeComp" >
        { selectedTab === 'county' &&
          <div className="row countyAndZipcodeDropdown" data-test="county">
            {this.renderGeographicsCountyCatDropdown()}
          </div>
  }
        { selectedTab === 'zipcode' &&
          <div className="row countyAndZipcodeDropdown" data-test="zipcode">
            {this.renderGeographicsZipcodeCatDropdown()}
          </div>
        }
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    geoMappingActions: bindActionCreators(geoMappingActions, dispatch),
  };
}

CountyAndZipCodeCategoryDropdown.propTypes = {
  geoMappingActions: PropTypes.shape({
    updateCountyAndZipcodeCategory: PropTypes.func,
    getGeoghrapicsData: PropTypes.func,
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
    }),
  }),
  zipcodeCategorySelectedVal: PropTypes.string,
  countyCategorySelectedVal: PropTypes.string,
  selectedTab: PropTypes.string,
  clearAll: PropTypes.func,
};


function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    selectedGeographicsTabIndex: state.geomap.selectedGeographicsTabIndex,
    countyCategorySelectedVal: state.geomap.countyCategorySelectedVal,
    zipcodeCategorySelectedVal: state.geomap.zipcodeCategorySelectedVal,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CountyAndZipCodeCategoryDropdown);

